export enum UserType {
    owner = 1,
    employee,
    user
}
